import React from "react";
import { ArrowLeft } from "lucide-react";
import { useSmartBack } from "../../hooks/useNavigationContext";

interface SmartBackButtonProps {
  fallbackPath: string;
  className?: string;
  children?: React.ReactNode;
}

const SmartBackButton: React.FC<SmartBackButtonProps> = ({
  fallbackPath,
  className = "text-link hover:text-hover flex items-center",
  children,
}) => {
  const { smartBack, backLabel } = useSmartBack(fallbackPath);

  return (
    <button onClick={smartBack} className={className}>
      <ArrowLeft className="h-5 w-5 mr-1 flex-shrink-0" />
      {children || backLabel}
    </button>
  );
};

export default SmartBackButton;
